<script>
    import store from '../../../Stores/usuario-edicion-store';
    import storeUsuarios from '../../../Stores/usuarios-store';

    import {validaUsuario} from '../../../Modelos/Usuario';

    import Caja from "../../UI/Caja.svelte";
    import Subtitulo from "../../UI/Subtitulo.svelte";
    import CampoDeTexto from "../../UI/CampoDeTexto.svelte";
    import CampoDeSeleccion from "../../UI/CampoDeSeleccion.svelte";
    import Boton from "../../UI/Boton.svelte";

    import {createEventDispatcher} from 'svelte';
    const dispatch = createEventDispatcher();

    let usuario, error, errores;
    $: usuario = $store.usuario;
    $: errores = validaUsuario(usuario);
    $: error = $store.error;

    let estadoInicial;
    $: estadoInicial = estadoInicial || $store.usuario;

    let sucio = false;
    $: sucio = JSON.stringify(estadoInicial) !== JSON.stringify($store.usuario);

    const tiposDeUsuario = ['Actividad', 'Ausencia'];

    const actualizaCampo = (campo, valor) => store.actualizaCampo(campo, valor);

    const enviaFormulario = e => {
        e.preventDefault();
        estadoInicial = null;
        store.guarda().then(() => storeUsuarios.cargar()).then(() => dispatch('enviado'));
    };
</script>

<style>
    @media (min-width: 1024px) {
        .fila {
            display: grid;
            grid-template-columns: 1fr 1fr;
            grid-gap: var(--padding-global);
        }

        .fila-3 {
            display: grid;
            grid-template-columns: repeat(3, 1fr);
            grid-gap: var(--padding-global);
        }
    }
</style>

<Caja>
    <div slot="titulo">
        <Subtitulo>
            {usuario.nombre}
        </Subtitulo>
    </div>

    <form on:submit={enviaFormulario}>
        <div class="fila">
            <CampoDeTexto id="nombre" label="Nombre" value={usuario.nombre}
                          icono="chat_bubble_outline" valido={!errores.nombre}
                          mensajeDeError={errores.nombre}
                          on:input={e => actualizaCampo('nombre', e.target.value)}/>

            <CampoDeTexto id="email" label="E-mail" value={usuario.email}
                          icono="contact_mail" valido={!errores.email}
                          mensajeDeError={errores.email}
                          on:input={e => actualizaCampo('email', e.target.value)}/>
        </div>

        <div class="fila">
            <CampoDeTexto id="password" label="Contraseña"
                          value={usuario.password === undefined ? '' : usuario.password}
                          icono="lock" valido={!errores.password}
                          mensajeDeError={errores.password} type="password"
                          on:input={e => actualizaCampo('password', e.target.value)}/>

            <CampoDeTexto id="password" label="Repetir contraseña"
                          value={usuario.password2 === undefined ? '' : usuario.password2}
                          icono="lock" valido={!errores.password2}
                          mensajeDeError={errores.password2} type="password"
                          on:input={e => actualizaCampo('password2', e.target.value)}/>
        </div>
    </form>

    <div slot="pie">
        <Boton on:click={enviaFormulario} type="submit"
               disabled={!sucio || Object.keys(errores).length}>
            Guardar
        </Boton>
    </div>
</Caja>